module.exports = __webpack_public_path__ + "OpenSans-Regular-webfont.79515ad0788973c53340.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OpenSans-Regular-webfont.woff
// module id = 1140
// module chunks = 30